@if (alertInfo.show) {
  <ngb-alert [type]="alertInfo.type" (closed)="alertInfo.show = false" class="mb-3">
    {{ alertInfo.message }}
  </ngb-alert>
}

@if (commissions.length === 0) {
  <div class="commission-empty">
    <div class="commission-empty-box">
      Empty commissions. Click on "Add new commission" to add a new commission
    </div>
  </div>
}

@if (commissions.length > 0) {
  <div class="commission-table">
    <div class="commission-header-row">
      <span class="commission-col-label">&gt; Start date</span>
      <span class="commission-col-label">End date</span>
      <span class="commission-col-label">Revenue</span>
      <span class="commission-col-actions"></span>
    </div>

    @for (commission of commissions; track $index) {
      <div class="commission-row">
        <div class="commission-col">
          <input
            type="date"
            class="form-control form-control-sm shadow-sm"
            [class.is-invalid]="isFieldInvalid($index, 'startDate')"
            [value]="commission.startDate"
            (change)="updateField($index, 'startDate', $any($event.target).value)"
          />
        </div>
        <div class="commission-col">
          <input
            type="date"
            class="form-control form-control-sm shadow-sm"
            [class.is-invalid]="isFieldInvalid($index, 'endDate')"
            [value]="commission.endDate"
            (change)="updateField($index, 'endDate', $any($event.target).value)"
          />
        </div>
        <div class="commission-col commission-col-pct">
          <div class="input-group input-group-sm shadow-sm">
            <input
              type="number"
              class="form-control"
              [class.is-invalid]="isFieldInvalid($index, 'revenuePercent')"
              [value]="commission.revenuePercent"
              (input)="updateField($index, 'revenuePercent', +$any($event.target).value)"
              min="0"
              max="100"
            />
            <span class="input-group-text">%</span>
          </div>
        </div>
        <div class="commission-col-actions">
          <button
            type="button"
            class="btn btn-sm btn-danger"
            (click)="confirmDeleteCommission($index)"
            title="Delete commission"
          >
            <i class="fa fa-trash"></i>
          </button>
        </div>
      </div>
    }
  </div>
}

<div class="d-flex justify-content-center mt-3">
  <button type="button" class="btn btn-primary btn-sm px-3" (click)="addCommission()">
    <i class="fa fa-plus me-1"></i> Add new commission
  </button>
</div>
